const tracks = [
  {
    id: 0,
    name: "i'm just a dog",
    album: "Parmesan Dreams",
    artist: "Parmesan Dreams",
    duration: 248,
    covers: ["1.gif"],
    path: "assets/01_i'm_just_a_dog.mp3",
  },
  {
    id: 1,
    name: "once in a while",
    album: "Parmesan Dreams",
    artist: "Parmesan Dreams",
    duration: 212,
    covers: ["2.gif"],
    path: "assets/02_once_in_a_while.mp3",
  },
  {
    id: 2,
    name: "idk what i'm looking for",
    album: "Parmesan Dreams",
    artist: "Parmesan Dreams",
    duration: 225,
    covers: ["3.gif"],
    path: "assets/03_idk_what_i'm_looking_for.mp3",
  },
  {
    id: 3,
    name: "don't feed the wolves",
    album: "Parmesan Dreams",
    artist: "Parmesan Dreams",
    duration: 267,
    covers: ["4.gif"],
    path: "assets/04_don't_feed_the_wolves.mp3",
  },
];

export default tracks;
